import React from "react";
import DetailRow from "./DetailRow";

const bindExpandCell = onChange => props => (
  <DetailRow {...props} onChange={onChange} />
);

export default bindExpandCell;
